import { useIntl } from 'react-intl';
import { SimpleGrid } from '@chakra-ui/react';
import ComboboxFormikField from 'components/forms/ComboboxFormikField';

const ForwardPriceTab = ({ options }) => {
    const intl = useIntl();

    return (
        <SimpleGrid spacingX={6} spacingY={5} columns={3}>
            <ComboboxFormikField
                id="refForwardOnPeakId"
                name="refForwardOnPeakId"
                label={intl.formatMessage({ id: 'basis_tabs_ref_forward_on_peak' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="refForwardOffPeakId"
                name="refForwardOffPeakId"
                label={intl.formatMessage({ id: 'basis_tabs_ref_forward_off_peak' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="refForwardATCId"
                name="refForwardATCId"
                label={intl.formatMessage({ id: 'basis_tabs_ref_forward_atc' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="delForwardOnPeakId"
                name="delForwardOnPeakId"
                label={intl.formatMessage({ id: 'basis_tabs_del_forward_on_peak' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="delForwardOffPeakId"
                name="delForwardOffPeakId"
                label={intl.formatMessage({ id: 'basis_tabs_del_forward_off_peak' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
            <ComboboxFormikField
                id="delForwardATCId"
                name="delForwardATCId"
                label={intl.formatMessage({ id: 'basis_tabs_del_forward_atc' })}
                options={options.forwardPrices}
                labelKey="description"
                valueKey="id"
                showPlaceholder={true}
                placeholderValue={null}
            />
        </SimpleGrid>
    );
};

export default ForwardPriceTab;
